import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useCanvasSession } from '../contexts/CanvasSessionContext';
import { useUiOverlay } from '../contexts/useUiOverlay';
import { consumePendingGenerationIntent } from '../lib/generation-intent';

/** After sign-in, resume a home-prompt generation that was blocked by auth. */
export function usePendingGenerationResume(): void {
  const { user, isLoading } = useAuth();
  const { startFromIntent } = useCanvasSession();
  const { hideHome } = useUiOverlay();
  const resumedRef = useRef(false);

  useEffect(() => {
    if (isLoading || !user || resumedRef.current) {
      return;
    }
    const pending = consumePendingGenerationIntent();
    if (!pending) {
      return;
    }
    resumedRef.current = true;
    hideHome();
    void startFromIntent({ query: pending.query, focus: pending.focus });
  }, [user, isLoading, startFromIntent, hideHome]);
}
